// To generate a new file similar to this one, run `pay js:run gql-v1 --type=mutation --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

import type {
  V1MutationOptions,
  V1MutationOptionsWithoutVariables,
  V1MutationReturn,
  AccountToken,
} from '@stripe-internal/data-v1/types';
/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';
import {useV1Mutation} from '@stripe-internal/data-v1';

import type {GraphQlDocument, HookVariables} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiPostV1CryptoInternalPayinSessionCryptoPayinSessionAllocateDepositAddressInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  mutation AllocateDepositAddressMutation(
    $input: OpenapiPostV1CryptoInternalPayinSessionCryptoPayinSessionAllocateDepositAddressInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalPayinSessionCryptoPayinSessionAllocateDepositAddress(
      input: $input
      v1Context: $v1Context
    ) {
      deposit_address
    }
  }
`;

export const allocateDepositAddressMutation: AllocateDepositAddressMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const allocateDepositAddressMutationOptions: V1MutationOptionsWithoutVariables<AllocateDepositAddressMutationDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function useAllocateDepositAddressMutation<
  THookVariables extends HookVariables<AllocateDepositAddressMutationVariables> = {},
>(
  options: V1MutationOptions<
    AllocateDepositAddressMutationDocument,
    THookVariables
  > = {},
): V1MutationReturn<AllocateDepositAddressMutationDocument, THookVariables> {
  return useV1Mutation(allocateDepositAddressMutation, {
    ...allocateDepositAddressMutationOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type AllocateDepositAddressMutationVariables = Exact<{
  input?: InputMaybe<OpenapiPostV1CryptoInternalPayinSessionCryptoPayinSessionAllocateDepositAddressInput>;
  v1Context: V1ContextInput;
}>;

export type AllocateDepositAddressMutationData = {
  readonly __typename: 'Mutation';
  readonly v1CryptoInternalPayinSessionCryptoPayinSessionAllocateDepositAddress: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceDirectDepositAddress';
    readonly deposit_address: string;
  } | null;
};

export type AllocateDepositAddressMutationToken = AccountToken<{
  Mutation_v1CryptoInternalPayinSessionCryptoPayinSessionAllocateDepositAddress: true;
}>;

// Temporarily duplicating the token type to facilitate migration.
// This will be removed as part of go/rename-permissions-to-token work.
export type AllocateDepositAddressMutationPermissions =
  AllocateDepositAddressMutationToken;

export type AllocateDepositAddressMutationDocument = GraphQlDocument<
  AllocateDepositAddressMutationData,
  AllocateDepositAddressMutationVariables,
  AllocateDepositAddressMutationToken
>;
